import { ToastUtility } from "@syncfusion/ej2-vue-notifications";

const toasterService = {
    success(msg:string){
        ToastUtility.show({
                content:msg,
                cssClass:"e-toast-success most-top",
                timeOut:2500,
                icon:"fas fa-check-circle",
                position:{X:"Right",Y:"Bottom"},
                animation: {
                    show: { effect: "SlideRightIn" },
                    hide: { effect: "SlideRightOut" },
                },
            });
    },
    error(msg:string, timeOut = 2800){
        ToastUtility.show({
            content:msg,
            cssClass:"e-toast-danger most-top",
            timeOut: timeOut,
            icon:"fas fa-bug",
            position:{X:"Right",Y:"Bottom"},
            animation: {
                show: { effect: "SlideRightIn" },
                hide: { effect: "SlideRightOut" },
            },
        });
    },
    warn(msg:string){
        ToastUtility.show({
            content:msg,
            cssClass:"e-toast-warning most-top",
            timeOut:2800,
            icon:"fas fa-exclamation",
            position:{X:"Right",Y:"Bottom"},
            animation: {
                show: { effect: "SlideRightIn" },
                hide: { effect: "SlideRightOut" },
            },
        });
    },
    info(msg:string){
        ToastUtility.show({
            content:msg,
            cssClass:"e-toast-info",
            icon:"fas fa-exclamation",
            timeOut:2500,
            position:{X:"Right",Y:"Bottom"},
            animation: {
                show: { effect: "SlideRightIn" },
                hide: { effect: "SlideRightOut" },
            },
        });
    },
    
}

export default toasterService;